
import { defineComponent,computed } from "vue";

export default defineComponent({
  props: {
    currentPage: {//当前页
      type: Number,
      default: 1,
    },
    limit:{//每页显示条数
      type: Number,
      default: 15,
    },
    totalCount:{//总条数
      type: Number,
      default: 0,
      required: true
    },
    type:{//每页显示条数
      type: String,
      default: "normal",
    },
  },
  data(){
    return {
      goPage:'',
      limitNum:0,
      limitNums:[5,10,15,20,25,30],
      toPrev:false,
      toNext:false,
    }
  },
  
  methods: {
    turn(e: any){
      let i = e;
      if(i<1){
        i=1;
      }else if(i > this.totalPage){
        i = this.totalPage;
      }
      this.$emit("turn", i);
    }
  },
  setup(props) {
    const totalPage = computed(() => {
      return Math.ceil(props.totalCount / props.limit);
    });
    const showPageBtn = computed(() => {
      const pageNum = totalPage.value,
        index = props.currentPage,
        arr = [];
      if (pageNum <= 9) {
        for(let i = 1; i <= pageNum; i++) {
          arr.push(i)
        }
        return arr
      }
      if (index < 5) return [1,2,3,4,5,6,7,'+',pageNum]
      if (index >= pageNum -1) return [1,2,'-', pageNum -5,pageNum -4,pageNum -3, pageNum -2, pageNum -1, pageNum]
      if (index === pageNum -2) return [1,2,'-', pageNum -5,pageNum -4,pageNum-3, pageNum-2, pageNum-1, pageNum]
      return [1,'-', index-2,index-1, index, index + 1,index + 2, '+', pageNum]
    })
    return {
      totalPage,
      showPageBtn,
    };
  },
  created(){
    this.limitNum=this.limit;
    if (!this.limitNums.includes(this.limit)) {
      this.limitNums.push(this.limit);
      this.limitNums.sort(function (a: any, b: any) {
        return a-b;
      });
    }
  }
});
